// @flow weak

import React, {
  Component
} from 'react';
import PropTypes from 'prop-types';
import {
  NavigationBar,
  BackToTop
} from '../../components';
import navigationModel from '../../config/navigation.json';
import MainRoutes from '../../routes/MainRoutes';
import Tree from '../../views/tree/Tree';
import Search from '../../views/search/Search';

class App extends Component {
  static propTypes = {
    // react-router 4:
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,

    // views:
    currentView: PropTypes.string

  };

  state = {
    navModel: navigationModel
  };


  toggle(e) {
    var tree = jQuery('#fbc-tree');
    if (tree.is(':visible')) {
      tree.animate({ "left": "-250px" }, "slow").hide();
      jQuery('#hideShow>i').addClass('fa-bars');
      jQuery('#hideShow>i').removeClass('fa-close');
      jQuery('#__attachments-view-fbc').css({ 'padding-left': '0px' });
    } else {
      tree.animate({ "left": "0px" }, "slow").show();
      jQuery('#hideShow>i').removeClass('fa-bars');
      jQuery('#hideShow>i').addClass('fa-close');
      jQuery('#__attachments-view-fbc').css({ 'padding-left': '250px' });
    }
  }

  handleSearch(e) {
    this.setState({
      search: e,
      filter: '',
      album: { name: "Recent Images" },
      type: 'search'
    });
  }

  handleFilter(e) {
    this.setState({
      filter: e,
      type: 'filter'
    });
  }

  render() {
    const { navModel } = this.state;

    return (
      <div id="fbc-react">
        <Tree load={true} />

        <div className="searchRow">
          <a className="btn" id="hideShow" onClick={this.toggle}>
            <i className="fa fa-bars"></i>
          </a>
          <p id="fbc-results">
            <strong id="fbc-res">Album:</strong> <span id="fbc-album">Main Library</span> &nbsp;&nbsp;&nbsp;
            <strong>Files:</strong> <span id="fbc-currentCnt"></span> / <span id="fbc-found"></span>
          </p>
          <Search load={true} />
        </div>


        <div id="fbc-loop"></div>

        <MainRoutes />

      </div>
    );
  }

  handleLeftNavItemClick = (event, viewName) => {
    // something to do here?
  }

  handleRightNavItemClick = (event, viewName) => {
    // something to do here?
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app/containers/app/App.js